"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAIConnector = exports.OpenAIModel = exports.OpenAIKey = void 0;
const zod_1 = require("zod");
require("openai/shims/web"); // FIXME 'web' fails on frontend/ts-src/types/ports.test.disabled.ts tests :/
const openai_1 = __importDefault(require("openai"));
// create a key: https://platform.openai.com/api-keys
exports.OpenAIKey = zod_1.z.string();
exports.OpenAIModel = zod_1.z.enum(['gpt-4o', 'gpt-4-turbo', 'gpt-3.5-turbo']);
class OpenAIConnector {
    constructor(opts) {
        this.opts = opts;
        this.query = async (system, user) => {
            // console.log(`system: ${system}`)
            // console.log(`user: ${user}`)
            // https://platform.openai.com/docs/api-reference/chat/create
            const completion = await this.openai.chat.completions.create({
                model: this.opts.model,
                messages: [
                    { role: 'system', content: system },
                    { role: 'user', content: user },
                ].filter(m => m.content),
            });
            const answer = completion.choices?.[0].message.content;
            // console.log(`answer ${this.opts.model}: ${answer}`)
            return answer || 'Invalid LLM answer :/';
        };
        this.openai = new openai_1.default({ apiKey: opts.apiKey, dangerouslyAllowBrowser: true });
    }
}
exports.OpenAIConnector = OpenAIConnector;
//# sourceMappingURL=openai.js.map